import Modal from "react-bootstrap/Modal";

import "./style.css";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { apiEditItemCat } from "../../../api/master";
import itemCatSchema from "../../../validations/ItemCat";

function CompanyEdit(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [shownew, setShownew] = useState(false);

  const itemCatFormik = useFormik({
    initialValues: {
      item_cat_id: props.id?.item_cat_id,
      item_cat_name: props.id?.item_cat_name,
    },
    validationSchema: itemCatSchema.validateItemCatAdd(),
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (values) => {
      values = {
        item_cat_id: values.item_cat_id,
        item_cat_name: values.item_cat_name,
      }
      setIsSubmit(true);
      await apiEditItemCat(values)
        .then((data) => {
          setSuccess(data.data.message);
          setError("");
          props.list();
        })
        .catch((err) => {
          setError(err.response.data.data.message);
          setSuccess("");
        })
        .finally((result) => {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  })

  useEffect(function () {}, [success, error]);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Edit Item Category
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="buyerAdd">
        <form
          className="row gx-5 gy-2"
          onSubmit={itemCatFormik.handleSubmit}
          autoComplete="off"
        >
          <div className="col-md-12">
            <label htmlFor="item_cat_name">
              Item Category Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              maxLength={50}
              className="form-control"
              id="item_cat_name"
              {...itemCatFormik.getFieldProps("item_cat_name")}
            />
            {itemCatFormik.errors.item_cat_name && shownew != true ? (
              <div className="text-danger small">
                {itemCatFormik.errors.item_cat_name}
              </div>
            ) : null}
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert"
              >
                {error || success || ""}
              </div>
            )}
            <div style={{ float: "right" }}>
              <button
                className="branchModalCancel"
                onClick={props.hide}
                type="button"
              >
                Cancel
              </button>
              {shownew ? (
                <button
                  id="createNew"
                  onClick={() => {
                    itemCatFormik.resetForm();
                    setShownew(false);
                    setSuccess("");
                  }}
                >
                  Add New
                </button>
              ) : (
                <button type="submit" disabled={isSubmit}>
                  {isSubmit && (
                    <span className="spinner-border spinner-border-sm me-2"></span>
                  )}
                  Save
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default CompanyEdit;
